import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalShell from 'components/common/ModalShell';
import { buttonClasses } from 'components/common/tailwindClassnames';
import { useTutorial } from './TutorialContext';

// GUNDI-5665: confirmation gate before the tour. Uses the app-wide ModalShell
// (product call) so it looks like every other dialog. ModalShell's Esc/overlay
// close maps to Cancel — declining the tour, not exiting a running one.
//
// TEMPORARY (≤3 weeks) — see the removal manifest in tutorialInterceptor.ts.
export default function TutorialStartModal() {
  const { t } = useTranslation();
  const { status, cancelStart, confirmStart } = useTutorial();
  if (status !== 'confirming') return null;

  return (
    <ModalShell
      title={t('Take a tour of the new Gundi')}
      onClose={cancelStart}
      footer={
        // ModalShell's footer is flex-row-reverse: first child sits on
        // the right, so "Start tour" is the rightmost action.
        <>
          <button
            type="button"
            data-testid="TutorialStartModal-start-button"
            onClick={confirmStart}
            className={buttonClasses.primary}
          >
            {t('Start tour')}
          </button>
          <button
            type="button"
            data-testid="TutorialStartModal-cancel-button"
            onClick={cancelStart}
            className={buttonClasses.cancel}
          >
            {t('Cancel')}
          </button>
        </>
      }
    >
      <p className="text-base font-normal text-ui-text-primary-text">
        {t(
          "The tour focuses on what's new: Routes, Connections, and how to configure them. It takes about two minutes.",
        )}
      </p>
      <p className="mt-3 text-base font-semibold text-ui-text-primary-text">
        {t(
          'Before you start, save any work in progress — unsaved changes may be lost during the tour.',
        )}
      </p>
    </ModalShell>
  );
}
